
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-system/radio-toggle-button",
      function () {
        return require("private-next-pages/design-system/radio-toggle-button.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/design-system/radio-toggle-button"])
      });
    }
  